module.exports = __webpack_public_path__ + "assets/img/feedback_title.360d3677.png";